import React from 'react';
import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import '../styles/Card.css';

export default function ProjectCard(props) {

    return (
        <Card style={{ width: '20rem', height: "28rem" }} className="card">
            <iframe src={props.fileLink} height="310" title="myFrame" style={{ border: 0 }} loading="lazy" ></iframe>
            <Link to={props.url} target="_blank" onClick={(event) => { event.preventDefault(); window.open(props.url); }}>
                <Card.Body>
                    <Card.Title style={{ color: "lightgray" }}>
                        {props.title}
                    </Card.Title>
                    <Card.Text className="font-weight-light text-white">
                        {props.content}.
                    <span className="d-flex flex-row font-italic font-weight-light text-sm">stacks:
                        {props.stacks.map((item, index) => (
                            <span
                                className="ml-1"
                                key={index}
                                style={{ color: "thistle" }}
                            >
                                {item}
                            </span>
                        ))}
                        </span>
                    </Card.Text>
                </Card.Body>
            </Link>
        </Card>
    )
}
